import { useEffect, useState } from 'react';
import { rpc } from '../admin/api';

export type SchoolFacts = { state: string; created_at: string; classes_without_teacher: string[] | null };

// B13, B14, B16: when the school was created and whether it is Live, from
// school_readiness() (0020), to trim history from before the school existed.
export function useSchoolDates() {
  const [d, setD] = useState<SchoolFacts | null>(null);
  useEffect(() => {
    rpc<SchoolFacts>('school_readiness').then((r) => !r.error && setD(r.data));
  }, []);
  return d;
}
